/*
 * Module for support contact us view
*/
rs.module("ui/content/support/contactus",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, listApi) {

            // Unpack Js Selectors
            var contactUs = $.js(jsSelectors.contactUs);
            var listItems = listApi.items();

            // Run onload functions
            setListHeight();

            // Assert the list control's height for the contact us page.
            // This prevents the page from collapsing when accessed externally.
            function setListHeight() {

                // Get total height of list items
                var totalHeight = contactUs.outerHeight();
                listItems.each(function () {
                    totalHeight = totalHeight + Math.ceil($(this).outerHeight());
                });

                // set height of contents
                contactUs.height(totalHeight);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);